const hashStringToSeed = (value: string): number => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

const mulberry32 = (seed: number) => {
  return () => {
    let t = (seed += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

export const createDeterministicOrder = (length: number, seedKey: string): number[] => {
  const order = Array.from({ length }, (_value, idx) => idx);
  const random = mulberry32(hashStringToSeed(seedKey));
  for (let i = order.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }
  return order;
};

export const rankingOrderToSelections = (orderedStatementIndexes: number[]): number[] => {
  const selections = Array(orderedStatementIndexes.length).fill(0);
  orderedStatementIndexes.forEach((statementIndex, rankIndex) => {
    selections[statementIndex] = rankIndex;
  });
  return selections;
};

export const rankingSelectionsToOrder = (selections: readonly (number | null)[]): number[] | null => {
  const order: number[] = Array(selections.length);

  for (const [statementIndex, rank] of selections.entries()) {
    if (rank == null || !Number.isInteger(rank) || rank < 0 || rank >= selections.length || order[rank] != null) {
      return null;
    }
    order[rank] = statementIndex;
  }

  return order;
};
